export enum FolderType {
  MODEL = 'MODEL',
  CONTRACT = 'CONTRACT',
  COMPANY_LIBRARY = 'COMPANY_LIBRARY',
  EMPLOYEE_LIBRARY = 'EMPLOYEE_LIBRARY',
}
